import React from 'react';
import './App.css';
import './styles.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Container from './app/Container';
import ContainerUniversity from './app/ContainerUniversity';
import { Login } from './app/components/auth/Login';
import { Authenticated } from './app/components/auth/Authenticated';
import { useStoreActions, useStoreState } from './app/store/hooks/easyPeasy';

function App() {
	const checkAuth = useStoreActions(state => state.auth.checkAuth);
	const checkType = useStoreState(state => state.auth.checkType)
	checkAuth();
	return (
		<Router>
			<Switch>
				<Route exact path="/login">
					<Login />
				</Route>
				<Authenticated path="/" component={checkType==='school'?Container:ContainerUniversity} />
			</Switch>
		</Router>
	);
}

export default App;
